export const firebaseConfig = {
    apiKey: "AIzaSyAwSBY4kRulyt4fDtsfFpye03pj6SpvGsg",
    authDomain: "code-ify.firebaseapp.com",
    projectId: "code-ify",
    storageBucket: "code-ify.appspot.com",
    messagingSenderId: "552865281207",
    appId: "1:552865281207:web:243e7bd00c5bf7aa6fc932",
    measurementId: "G-D22VFB6L7S"
};